import styled from '@emotion/styled';
import Comment from '@engineering/icons/comment';
import { Button } from '@silvertours/front-shared';
import { HeaderIconStyles } from '../Header.styles';

const PhoneInfoPopoverWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ContactIconButton = styled(Button)`
  padding: 0;
  background: none;

  :hover {
    background: none;
  }
`;

const ContactIcon = styled(Comment)`
  ${HeaderIconStyles};
  fill: ${({ theme }) => theme.color.button};
  min-width: ${({ theme }) => theme.spacing[50]};
`;

export { ContactIcon, PhoneInfoPopoverWrapper, ContactIconButton };
